import {makeItemsListUrl} from '@frontend/helpers'
import {mdiChevronRight} from '@mdi/js'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {Icon} from 'swayok-react-mdb-ui-kit/components/Icon/Icon'
import {useUrlQueryParams} from 'swayok-react-mdb-ui-kit/helpers/useUrlQueryParams'
import type {
    FilteredItemsPageUrlQueryParams,
    ItemsCategoryOrLocationForBreadcrumbs,
} from '../AdsModuleTypes'

interface Props {
    path: ItemsCategoryOrLocationForBreadcrumbs[]
    className?: string
}

// Путь к категории объявления.
export function AdsOrServicesBreadcrumbs(props: Props) {

    const {
        path,
        className,
    } = props

    const {urlQueryParams} = useUrlQueryParams<FilteredItemsPageUrlQueryParams>()
    const queryParamsForBreadcrumbs: FilteredItemsPageUrlQueryParams = {}
    if (urlQueryParams.has('location')) {
        queryParamsForBreadcrumbs.location = urlQueryParams.get('location')
    }
    if (urlQueryParams.has('minPrice')) {
        queryParamsForBreadcrumbs.minPrice = urlQueryParams.get('minPrice')
    }
    if (urlQueryParams.has('maxPrice')) {
        queryParamsForBreadcrumbs.maxPrice = urlQueryParams.get('maxPrice')
    }
    if (urlQueryParams.has('keywords')) {
        queryParamsForBreadcrumbs.keywords = urlQueryParams.get('keywords')
    }

    const items = []
    for (let i = 0; i < path.length; i++) {
        const pathItem: ItemsCategoryOrLocationForBreadcrumbs = path[i]
        items.push(
            <Link
                key={'path-item-' + pathItem.id}
                to={makeItemsListUrl(pathItem, {...pathItem.urlQueryParams, ...queryParamsForBreadcrumbs})}
            >
                {pathItem.name}
            </Link>
        )
        if (i !== path.length - 1) {
            items.push(
                <Icon
                    key={'separator-' + i}
                    path={mdiChevronRight}
                    size={16}
                    color="muted"
                    className="mx-1"
                />
            )
        }
    }

    return (
        <div
            id="offered-items-breadcrumbs"
            className={clsx(
                'flex-row-center justify-content-start flex-wrap',
                className
            )}
        >
            {items}
        </div>
    )
}
